export default __webpack_public_path__ + "static/media/md-card-bg-Docker.8d6405ff.png";